const registerScenes = ngModule => {};

export default registerScenes;
